export const BI_EVENT_IDS = {
  PLATFORM_INSTALLATION: 114,
  PROVISION_APPS: 115,
  NEW_COMPONENTS_INSTALL: 116,
  UNIFIED_APP_INSTALL: 117,
  INSTALL_CODE_PACKAGES: 118,
  PLATFORM_RUN_SCRIPTS: 119,
  NAVIGATE_TO_DEV_CENTER: 120,
  PLATFORM_ERROR: 121,
};

export const APP_SCHEMA_VERSIONS = {
  EXTERNAL_UNIFIED_COMPONENT: 'externalUnifiedComponents',
};

export const UNIFIED_COMPONENTS_PROTO_CHANGES =
  'specs.editor-platform.unified-components-proto-changes';
